import React, { useState, useEffect } from 'react';
import { UilSearch, UilLocationPoint , UilMap, UilSync} from "@iconscout/react-unicons";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
function Searchbar({ onCitySelect, onToggleTemperatureUnit})  {

    const [searchQuery, setSearchQuery] = useState("");
    const [temperatureUnit, setTemperatureUnit] = useState('Celsius');
    const [animate, setAnimate] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cityList, setCityList] = useState([]);
    const [showMap, setShowMap] = useState(false);
    const [hoveredCity, setHoveredCity] = useState("");

    const handleLocationClick = () => {
      setLoading(true);
      setCityList([]);
      setSearchQuery("");
      setShowMap(false);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              async (position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                try {
                  setLoading(true);// started
                  const reverseGeocodeUrl = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`;
                  const reverseGeocodeResponse = await fetch(reverseGeocodeUrl);
                  const reverseGeocodeData = await reverseGeocodeResponse.json();
                  const city = reverseGeocodeData.city;
                  console.log("City:", city);
                  onCitySelect(city);
                  setLoading(false);
                }catch (error) {
                  console.error("Error getting weather data:", error.message);
                } finally {
                  setLoading(false); // data fetching is complete
                }
              },
            (error) => {
              console.error("Error getting user's location:", error.message);
                          }
          );
        } else {
            console.error("Geolocation is not supported by this browser.");
                      }
              };

   const handleInputClick = (e) => {
        e.target.select();
        setShowMap(false);
        setCityList([]);
        setLoading(false);
    };

    const handleSearchClick = async () => {
        setCityList([]);
        if (searchQuery.trim() !== "") {
            onCitySelect(searchQuery);
            setSearchQuery("");
            setShowMap(false);
        }else {
          setShowMap(false);
          setAnimate(true);
          setTimeout(() => {
          setAnimate(false);
            }, 500);
        }
        };
        
        const handleInputChange = (e) => {
          if (e.target.value.trim() !== "") {
            const url = `https://api.geoapify.com/v1/geocode/autocomplete?text=${e.target.value}&apiKey=db25aa0d0cf54251ba361f51355acca9`;
            fetch(url, { method: "GET" })
              .then((res) => res.json())
              .then((data) => {
                  const cities = data.features.map((feature) => feature.properties.formatted);
                  console.log(cities);
                  setCityList(cities);
              })
              .catch((error) => {
                console.error("Error fetching city data:", error.message);
                setCityList([]); // Clear the city list in case of an error
              });
            setSearchQuery(e.target.value);
          } else {
            console.log(e.target.value)
            setCityList([]);
            setAnimate(true);
            setSearchQuery("");
            setTimeout(() => {
              setAnimate(false);
            }, 500);
          }
        };

        const handleCityHover = (city) => {
          setHoveredCity(city);
        };    
    const handleToggleTemperatureUnit = (unit) => {
      setTemperatureUnit(unit);
      onToggleTemperatureUnit(unit);
    };

    function MapPopup({ onSelectCity }) {
      useEffect(() => {
        const newMap = L.map('map').setView([0, 0], 2);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(newMap);
    
        newMap.on('click', async (e) => {
          const { lat, lng } = e.latlng;
    
          try {
            const reverseGeocodeUrl = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lng}&localityLanguage=en`;
            const reverseGeocodeResponse = await fetch(reverseGeocodeUrl);
            const reverseGeocodeData = await reverseGeocodeResponse.json();
            const city = reverseGeocodeData.city;
    
            onSelectCity(city);
            setShowMap(false);
          } catch (error) {
            console.error('Error getting city data:', error.message);
          }
          });

        return () => {
          newMap.off('click');
          newMap.remove();
        };
      }, [onSelectCity]);
    
      return <div id="map" style={{ height: '400px', width: '100%' ,cursor:'crosshair'}} />;
    }

    const handleMapClick = () => {
      setShowMap(true);
    };
  
    const handleMapClose = () => {
      setShowMap(false);
    };

    return (
      
<div className="flex flex-row justify-center mx-1 ">
      <div className="flex relative flex-row w-screen items-center justify-center space-x-4 my-3">
          <div className="relative w-full">
                  <input
                    type="text"
                    value={hoveredCity || searchQuery}
                    onChange={handleInputChange}
                    onClick={handleInputClick}
                    /*onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        setCityList([]);
                        handleSearchClick();
                      }
                    }}*/
                    placeholder="Search for city..."
                    className={`${animate ? 'animate-shake' : 'animate-none'} text-xl  font-light p-2 w-full shadow-xl focus:outline-none capitalize placeholder:lowercase rounded-full pl-4`}
                  />
                  {searchQuery && (
                    <button
                    onClick={() => {
                      setSearchQuery("");
                      setCityList([]);
                    }}
                      className="absolute top-1/2 right-1 transform -translate-y-1/2 text-blue-300 transition ease-out hover:scale-125 focus:outline-none pr-2"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" strokeDasharray={12} strokeDashoffset={12} strokeLinecap="round" strokeWidth={2} d="M12 12L19 19M12 12L5 5M12 12L5 19M12 12L19 5">
                          <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="12;0"></animate>
                        </path>
                      </svg>
                    </button>
                  )}
            </div>
                <UilSearch
                    size={30}
                    onClick={() => !loading && handleSearchClick()}
                    className="text-white cursor-pointer transition ease-out hover:scale-125"
                />
                {loading ? (
                      <UilSync size={30} className="text-white cursor-pointer animate-spin" />
                    ) : (
                      <UilLocationPoint
                        size={30}
                        onClick={handleLocationClick}
                        className="text-white cursor-pointer transition ease-out hover:scale-125"
                      />
                )}

                <UilMap
                  size={30}
                  onClick={() => {
                      if(loading === false){
                        handleMapClick();
                        setCityList([]);
                        setSearchQuery("");
                    }
                    
                  }}
                  className="text-white cursor-pointer transition ease-out hover:scale-125"
                />  
                {showMap && (
                      <div className="map-popup absolute top-full right-0  mt-2 z-10 w-full cursor-crosshair">
                        <MapPopup onSelectCity={onCitySelect}  />
                        <button onClick={handleMapClose} className="absolute right-0 text-white cursor-pointer"
                        >X</button>
                      </div>
                )}


          {cityList.length > 0 && searchQuery.trim() !== "" && (
            <div className="absolute top-full -left-2 z-10 mt-1 bg-gray-200/80 border rounded-lg shadow-full w-11/12">
              {cityList.map((city, index) => (
                <div
                  key={index}
                  className={`p-2 cursor-pointer hover:bg-white ${
                    index < cityList.length - 1 ? 'border-b border-blue-300' : ''
                  }`}
                  onClick={() => {
                    setSearchQuery("");
                    setCityList([]);
                    onCitySelect(city);
                    setHoveredCity("");
                  }}
                  onMouseEnter={() => handleCityHover(city)}
                  onMouseLeave={() => handleCityHover("")}
                >
                  {city}
                </div>
              ))}
            </div>
          )}

          <div className="flex flex-row  items-center justify-center">
            <button
              name="metric"
             onClick={() => handleToggleTemperatureUnit('Celsius')}
              className={` text-white font-light transition ease-out hover:scale-125 ${temperatureUnit === 'Celsius' ? 'font-medium text-2xl' : 'font-light'}`}>
              °C
            </button>
            <p className=" text-white mx-1 cursor-none	">|</p>
            <button
              name="imperial"
              onClick={() => handleToggleTemperatureUnit('Fahrenheit')}
              className={` text-white mr-1 font-light transition ease-out hover:scale-125 ${temperatureUnit === 'Fahrenheit' ? 'font-medium text-2xl' : 'font-light'}`}>
              °F
            </button>
          </div>
        </div>
      
      </div>
      );
}


export default Searchbar


